import React, {Component} from 'react';

class Example extends Component {

    render() {
        return (<h1 style={{border:'3px solid blue'}}>Example</h1>);
    }
}

export default Example;